import api from "./axios";

export const getOnboardingStatusApi = async () => {
	const response = await api.get("/api/onboarding/status");
	return response.data;
};

export const selectUserTypeApi = async (payload: Record<string, unknown>) => {
	const response = await api.post("/api/onboarding/user-type", payload);
	return response.data;
};

export const submitOwnerBusinessInfoApi = async (payload: Record<string, unknown>) => {
	const response = await api.post("/api/onboarding/owner/business-info", payload);
	return response.data;
};

export const submitEmployerRoleApi = async (payload: Record<string, unknown>) => {
	const response = await api.post("/api/onboarding/employer/role", payload);
	return response.data;
};

export const submitEmployerBusinessInfoApi = async (payload: Record<string, unknown>) => {
	const response = await api.post("/api/onboarding/employer/business-info", payload);
	return response.data;
};

export const submitAgencyInfoApi = async (payload: Record<string, unknown>) => {
	const response = await api.post("/api/onboarding/agency/info", payload);
	return response.data;
};

export const addAgencyClientApi = async (agencyId: string, payload: Record<string, unknown>) => {
	const response = await api.post(`/api/onboarding/agency/${agencyId}/client`, payload);
	return response.data;
};

export const getOnboardingGoogleAuthUrlApi = async () => {
	const response = await api.get("/api/onboarding/google/auth-url");
	return response.data;
};

export const onboardingGoogleCallbackApi = async ({ code, state }: { code: string; state?: string | null }) => {
	const response = await api.get("/api/onboarding/google/callback", {
		params: { code, state },
	});
	return response.data;
};

export const discoverOnboardingLocationsApi = async (payload: Record<string, unknown> = {}) => {
	const response = await api.post("/api/onboarding/locations/discover", payload);
	return response.data;
};

export const selectOnboardingLocationsApi = async (payload: Record<string, unknown>) => {
	const response = await api.post("/api/onboarding/locations/select", payload);
	return response.data;
};

export const startOnboardingImportApi = async (payload: Record<string, unknown>) => {
	const response = await api.post("/api/onboarding/import", payload);
	return response.data;
};

export const completeOnboardingApi = async (payload: Record<string, unknown> = {}) => {
	const response = await api.post("/api/onboarding/complete", payload);
	return response.data;
};
